
import WMSCapabilities from 'ol/format/WMSCapabilities';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import * as xml from 'ol/xml';

export default {
    format: {
        WMSCapabilities,
        WMTSCapabilities
    },
    xml: xml
};
